import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Banner1.css';
import { useNavigate } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import s1 from '../images/directors.JPG';
import s2 from '../images/directors3.JPG';
// import s3 from '../images/certificate.jpg';


const Banner1 = () => {
  const words = ['Welcome to,', 'Seal Active'];
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      document.querySelector('.carousel-control-next').click();
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container-fluid app-banner d-flex justify-content-center align-items-center" style={{ height: '100vh', marginTop: '50px' }}>
      <div className="row align-items-center">
        <div className="col-md-5 text-section text-md-start text-center">
          <h1 className="banner-title">
            {words[0]}<br />
            <span className="highlighted-text-wrapper">
              <span className="highlighted-text">
                {words[1]}
              </span>
            </span>
          </h1>
          <p className="banner-description1">
            Welcome to SealActive Pvt Ltd, your trusted partner in adhesive solutions! With vast experience in corporate gluing technologies, we proudly represent HOT MELT AND COLD ADHESIVES in the Indian market. 
          </p>
          <button 
            className="btn download-btn" 
            onClick={() => navigate('/meeting')}
          >
            Schedule Meeting
          </button>
        </div>

        <div className="col-md-7 text-center">
          <Carousel interval={null}>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={s1}
                alt="First slide"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={s2}
                alt="Second slide"
              />
            </Carousel.Item>
            {/* <Carousel.Item>
              <img
                className="d-block w-100"
                src={s3}
                alt="Third slide"
              />
            </Carousel.Item> */}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Banner1;
